import { NavLink, Link, useNavigate, useParams } from 'react-router-dom'
import { FaShare } from 'react-icons/fa'
import { useState, useEffect } from "react";
import { alert_error, alert_success } from "../../AppContext.js";
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";
import Orders from './orders.jsx';
import Exchange from './exchange.jsx';
import Options from '../../shop/ai/options.jsx';
import Cash_diary from '../../nhatkyorders.jsx';
import Post_content from '../../community/content/Blog_posts.jsx';

function Home() {
  const navigate = useNavigate();
  const { slug_1, slug_2 } = useParams();
  return (
    <>
      <Tabs_nav category={'auto_tools'} />

      {slug_1 === "orders" && (
        <>
          <Orders />
        </>
      )}
      {slug_1 === "exchange" && (
        <>
          <Exchange />
        </>
      )}
      {slug_1 === "home_tools" && (
        <>
          <Options />
        </>
      )}
      {slug_1 === "history" && (
        <Exchange />
      )}
      {slug_1 === "tricks" && (
        <div className='mt-1 mb-3' >
          <Post_content mode={'hust_media'} show_adsense={'NO'} show_adskeeper={'YES'} uri={'auto_tools'} />
        </div>
      )}
    </>
  )
}
export default Home
